import React from 'react';
import Router from 'next/router';
import { ErrorLayout, MainLayout } from '@layouts';
import { getHelpSection } from '@modules/get-data';
import { ErrorContent } from '@components/Help-Center-Components';
import { ErrorConnection } from '@components/Help-Center-Components/error-connection';
import { HelpSectionPage } from '@sections/Help-Center-Sections';
import { PROCESSING_ITEMS, HELP_CENTER, IS_SERVER, HELP_ARTICLES_PER_PAGE } from '@constants';
import { getErrorContent, redirect, getPluralKey } from '@libs';

const HelpSection = ({ data }) => {
  return <HelpSectionPage data={data} section={data.section} />;
};

HelpSection.getLayout = (page, { data, locale, statusCode, isDisconnect }) => {
  const { translations, query } = page.props;

  if (isDisconnect) {
    return (
      <ErrorLayout>
        <MainLayout>
          <ErrorConnection />
        </MainLayout>
      </ErrorLayout>
    );
  }

  if (statusCode) {
    const error = getErrorContent({ code: statusCode });

    return (
      <ErrorLayout title={translations.t(error.title)}>
        <MainLayout reqQuery={query}>
          <ErrorContent error={error} locale={locale} />
        </MainLayout>
      </ErrorLayout>
    );
  }
  const metaTitle =
    data.meta_title ||
    `${data.total} ${translations.t(getPluralKey(data.total, `site.article.plural`))} ${translations.t(
      'site.help.metaTitleTemplate.article'
    )}`;

  const metaDescription = data.meta_description || translations.t('site.help.metaDescriptionTemplate.article');

  return (
    <MainLayout
      reqQuery={query}
      title={metaTitle}
      processing={PROCESSING_ITEMS.GET_HELP_SECTION}
      description={metaDescription}>
      {page}
    </MainLayout>
  );
};

HelpSection.getInitialProps = async ({ res, query, store }) => {
  const { category, page } = query;
  const { dispatch, getState } = store;
  const {
    settings: { locale },
  } = getState();
  const section = HELP_CENTER.DOCUMENTATION;

  if (page === '1') {
    const path = `/${locale}/${HELP_CENTER.MAIN}/${section}`;
    if (IS_SERVER && res) {
      redirect(path, {}, 301, res);
    } else {
      Router.push(path);
    }
    return {};
  }

  const data = await dispatch(
    getHelpSection({ section, category, page: Number(page) || 1, limit: HELP_ARTICLES_PER_PAGE })
  );
  const { errors } = getState();
  const error = errors[PROCESSING_ITEMS.GET_HELP];
  if (data.isDisconnect) {
    return { data, section, category, locale, isDisconnect: true };
  }
  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { data, section, category, locale, statusCode: error.code || 404 };
  }

  return { data, section, category, locale, statusCode: undefined, query };
};

export default HelpSection;
